import { render } from "./ChatInput.vue?vue&type=template&id=4b2c578e&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=4b2c578e&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c578e"]])

export default __exports__